<template>
  <div>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirItens" centered
      title="OS Socorro em Rotas">

      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">AÇÃO</th>
            <th scope="col">PLACA</th>
            <th scope="col">NÚMERO</th>
            <th scope="col">DATA</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ordemServico, index) in ordemServicos" :key="index">
            <th scope="row">
              <!-- <router-link :to="'os/' + ordemServico.nr_sequencial" size="sm" class="mr-2 btn btn-success">
                {{ $t('Acessar OS') }}
              </router-link> -->
              <button class="mr-2 btn btn-success"  size="sm" style="padding: 0.25rem 0.5rem; font-size: 0.875rem;"
              @click="acessarOs(ordemServico.nr_sequencial)">
                {{ $t('Acessar OS') }}
              </button>
            </th>
            <td>{{ ordemServico.nr_placa }}</td>
            <td>{{ ordemServico.nr_sequencial }}</td>
            <td>{{ ordemServico.dt_os | formatDate("DD/MM/YYYY HH:mm") }}</td>
          </tr>
        </tbody>
      </table>

      <template #modal-footer>
        <div class="w-100">
          <div class="row center" style="justify-content: center; ">
            <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showModalSocorro')">
              {{ $t('Fechar') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'ModalItems',
  data() {
    return {
      exibirItens: true,
    }
  },
  methods:{
    acessarOs(os) {
      window.location.href = window.location.origin + '/os/' + os
    }
  },

  computed: {
    ordemServicos() {
      const socorroRota = this.$store.getters['os/getSocorroRota']

      if (!socorroRota) {
        this.$store.dispatch('os/getSocorroRota')

        return {}
      }

      if (socorroRota.length == 0) {
        return false
      }

      return socorroRota
    },
    items() {
      return this.$store.getters['osItem/items']
    },
  },

  created() {
    this.getPlacasPreditivas()
  },
}
</script>
<style scoped>
#modalItems {
  pointer-events: none !important;
  height: 750px !important;
}

.close {
  display: none !important;
}

#totalPecas {
  height: 435px !important;
  overflow-x: auto !important;
}

.modal-content {
  height: 700px !important;
}

.divGerar {
  border: 1px solid #c1c1c1;
}
</style>